import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireRole } from '../lib/auth-guard.js';

// Layout-Route für den Client-Bereich. Rendert NUR die Kind-Routen via <Outlet/>.
// Der /client-Inhalt (Dashboard) liegt in client.index.tsx.
export const Route = createFileRoute('/client')({
  component: ClientAreaLayout,
  beforeLoad: async ({ context }) => {
    await requireRole(context.queryClient, ['client']);
  },
});

function ClientAreaLayout() {
  return <Outlet />;
}
